module.exports = __webpack_public_path__ + "img/thp-cms-logo.dd9e7b6c.jpg";